import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

import CardRaw from 'v3/components/Card';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';

import * as Styled from '../styles';

import {
  formatLink,
  formatNameCard
} from 'v3/pages/BlackList/controller';

import { formatDateTime } from 'v3/utils/formatter';

import { validatePermission } from 'actions/index';

function Card({ blacklistItem }) {

  const [hasPermissionToReason, setHasPermissionToReason] = useState(false);
  const nameCard = formatNameCard(blacklistItem);

  useEffect(() => {
    setHasPermissionToReason(validatePermission('VISUALIZAR_MOTIVO_BLACKLIST'));
  }, []);

  return (
    <Col md={6} className="d-flex mb-4">
      <CardRaw
        style={{ height: '100%' }}
        HeaderWrap="nowrap"
        header={
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              gap: '0.75rem',
              minWidth: 0,
              width: '100%',
            }}
          >
            <Link
              to={formatLink(blacklistItem)}
              target="_blank"
              style={{
                color: '#000000b5',
                cursor: 'pointer',
                minWidth: 0,
                overflow: 'hidden',
                textDecoration: 'none',
              }}
              title={nameCard}
            >
              <Text
                type="body"
                style={{
                  display: 'block',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {nameCard}
              </Text>
            </Link>
            {blacklistItem?.active ? (
              <Styled.Badge pill light type="error" className="mr-2">
                <Text type="label">Bloqueado</Text>
              </Styled.Badge>
            ) : (
              <Styled.Badge pill light type="success" className="mr-2">
                <Text type="label">Desbloqueado</Text>
              </Styled.Badge>
            )}
          </div>
        }
        HeaderRightComponent={
          hasPermissionToReason && (
            <Link to={`/blacklist/${blacklistItem?.id}`} color="black">
              <Button className="py-2">
                <Text color="white" type="regular" weight="500">
                  Detalhes
                </Text>
              </Button>
            </Link>
          )
        }
      >
        <Col style={{ gap: '0.5rem', display: 'flex', flexDirection: 'column' }}>
          {
            blacklistItem?.logs[0]?.title && (
              <Col className='p-0'>
                <Text color="gray" fontSize="14px" type="regular">
                  {blacklistItem?.logs[0]?.title}
                </Text>
              </Col>
            )
          }
          {
            hasPermissionToReason && (
              blacklistItem?.logs[0]?.reason && (
                <Col className="p-0" style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  <Text>
                    <Text color="gray" fontSize="14px" type="regular" weight={600}>
                      Motivo:
                    </Text>
                  </Text>
                  <Text color="gray" type="regular" style={{ 'word-break': 'break-all' }}>
                    {blacklistItem?.logs[0]?.reason}
                  </Text>
                </Col>
              )
            )
          }
          {
            blacklistItem?.logs[0]?.description && (
              <Col className="p-0" style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <Text color="gray" fontSize="14px" type="regular" weight={600} >
                  Descrição:
                </Text>
                <Text color="gray" type="regular" style={{ 'word-break': 'break-all' }}>
                  {blacklistItem?.logs[0]?.description}
                </Text>
              </Col>
            )
          }
          {
            blacklistItem?.logs[0]?.createdAt && (
              <Col className="p-0" style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <Text color="gray" fontSize="14px" type="regular" weight={600}>
                  Ultima atualização:
                </Text>
                <Text color="gray" type="regular">
                  {formatDateTime(blacklistItem?.logs[0]?.createdAt)}
                </Text>
              </Col>
            )
          }
        </Col>
      </CardRaw>
    </Col>
  );
}

export default Card;
